import { render, staticRenderFns } from "./Lesson-settings.vue?vue&type=template&id=672559fb&lang=html"
import script from "./Lesson-settings.vue?vue&type=script&lang=js"
export * from "./Lesson-settings.vue?vue&type=script&lang=js"
import style0 from "./Lesson-settings.vue?vue&type=style&index=0&id=672559fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports